import Loadable from '../../../components/loadable';

const ConfirmRemoveDeactivatedStyle = Loadable({
  loader: () => import('../../../pages/contacts/styles/confirm_remove_deactivated_style'),
  type: 'modal',
});

angular.module('gym').value('ConfirmRemoveDeactivatedStyle', ConfirmRemoveDeactivatedStyle);
